/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type IncomeIncomeType = (typeof IncomeIncomeType)[keyof typeof IncomeIncomeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncomeIncomeType = {
  employment: "employment",
  self_employment: "self_employment",
  rental: "rental",
  parental: "parental",
  pension: "pension",
  disability: "disability",
  orphan_or_widow_pension: "orphan_or_widow_pension",
  other: "other",
} as const;
